export var FormLabel = {
  baseStyle: {
    _disabled: {
      color: 'grey.450'
    }
  }
};